<template>
  <v-container fluid>
    <PageTitle>
      Edit Disclaimer
    </PageTitle>
    <v-form @submit.prevent="submit">
      <v-card class="mb-4">
        <v-card-text>
          <DisclaimerForm :form="form">
          </DisclaimerForm>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary">
            Save
          </v-btn>
          <v-btn :to="{name: 'admin.disclaimers.index'}">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click.prevent="deleteDisclaimer()"
                 color="error">
            Delete
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-form>

    <DisclaimerMockup :disclaimer="form">
    </DisclaimerMockup>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import DisclaimerForm from './components/DisclaimerForm.vue';
import disclaimerService from '../../services/disclaimerService';
import PageTitle from '../../components/PageTitle.vue';
import DisclaimerMockup from './components/DisclaimerMockup.vue';

export default {
  components: {DisclaimerMockup, PageTitle, DisclaimerForm},
  props: {
    disclaimer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form(disclaimerService.initForm(this.disclaimer)),
    }
  },
  computed: {},
  methods: {
    submit() {
      const form = this.form.data();
      form.presentations = this.form.presentations.map(p => p);
      this.form.patch(`/api/disclaimers/${this.disclaimer.id}`, {data: form})
        .then(response => {
          this.$emit('update');
          this.$router.push({name: 'admin.disclaimers.index'});
        })
        .catch(err => {

        })
    },
    deleteDisclaimer() {
      if (confirm('Are you sure you want to delete this disclaimer?')) {
        disclaimerService.deleteDisclaimer(this.disclaimer.id)
          .then(() => {
            this.$toast.success('Disclaimer deleted.');
            this.$router.replace({name: 'admin.disclaimers.index'});
          })
      }
    }
  }
}
</script>
